export default "__VITE_ASSET__DBaYeCmc__"